import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import AboutMe from './pages/AboutMe';
import Experience from './pages/Experience';
import Project from './pages/Project';
import { ThemeProvider } from '@mui/material';
import theme from './Theme';
import ContactMe from './pages/ContactMe';

const App: React.FC = () => {
  return (
    <Router>
      <ThemeProvider theme={theme}>
      <Layout>
        <Routes>
          <Route path="/" element={<AboutMe />}/>
          <Route path="/experience" element={<Experience />}/>
          <Route path="/projects" element={<Project />}/>
          <Route path="/contactMe" element={<ContactMe />}/>
        </Routes>
      </Layout>
      </ThemeProvider>
    </Router>
  );
};

export default App;
